(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["koha-newsletter"] && !Shopify.designMode) return;
  try {
    
  console.log('newsletter');
  $('#petType').change(function () {
    var petValue = $('#petType option:selected').val();
    $('#cTags').attr('value', petValue + ',newsletter');
    console.log(petValue);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["koha-product-template"]) return;
  try {
    
  // TAB FUNCTIONS
  $('.product-tabs li a').click(function (e) {
    e.preventDefault();
    var dataTab = $(this).data('tab');
    $('.product-tabs li a').removeClass('active');
    $(this).addClass('active');
    //console.log(dataTab);
    $('.tab-content').removeClass('active');
    $('.tab-content[data-tab="' + dataTab + '"]').addClass('active');
  });

  } catch(e) { console.error(e); }
})();
})();
